const data = {
  id: 1,
  title: 'Listen and choose the correct number',
  subTitle: 'Nghe và chọn số đúng',
  audioUrl: 'https://cloud.softech.cloud/storage/Data/Sentences/ac7a5fa5-a77f-4bc2-8c09-5275766d75d0.mp3',
  answers: [
    { id: 1, answer: '60', isCorrect: true },
    { id: 2, answer: '46', isCorrect: false },
    { id: 3, answer: '16', isCorrect: false },
  ],
  settings: {
    answers: {
      direction: 'horizontal',
      bulletType: 'none',
      // bulletType: 'character',
      // bulletType: 'number',
    },
  },
};

export default data;
